import { render } from "./LoadingAnimation.vue?vue&type=template&id=65743099&scoped=true"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=65743099&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65743099"]])

export default __exports__